import React from "react";
import { Breadcrumb } from "antd";
import { useNavigate } from "react-router-dom";
import BreadcrumbArrow from "../assets/images/breadcrumb-image-arrow.svg";

const CommonBreadcrumb = ({ items = [] }) => {
  const navigate = useNavigate();

  return (
    <Breadcrumb
      className="for-route-path-head"
      separator={<img src={BreadcrumbArrow} alt=">" />}
    >
      {items.map((item, index) => (
        <Breadcrumb.Item
          key={index}
          onClick={() => item.url && navigate(item.url)}
          style={{ cursor: item.url ? "pointer" : "default" }}
        >
          {item.title}
        </Breadcrumb.Item>
      ))}
    </Breadcrumb>
  );
};

export default CommonBreadcrumb;
